import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ValueMappingWidget: WidgetRegistryEntry = {
  name: "ValueMapping",
  component: () => import("./value-mapping-widget.component").then((m) => m.ValueMappingWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ValueMappingWidgetConfiguration)
};
